import React, { useState } from 'react';
import { TriggerIcons } from './TriggerIcons';
import { LoaderOverlay } from './LoaderOverlay';
import { MultiSelectInput } from './MultiSelectInput';
import type { BaseOptionType, CustomMultiselectProps } from './types';
import { CustomSelectContainer } from './styles';

export default function CustomMultiselect<T extends BaseOptionType = BaseOptionType>({
	options = [],
	value = [],
	placeholder,
	loading = false,
	onChange,
	className,
	onDropdownVisibleChange,
	...props
}: Readonly<CustomMultiselectProps<T>>): JSX.Element {
	const [isOpen, setIsOpen] = useState<boolean>(false);

	function handleOnDropdownVisibleChange(value: boolean): void {
		setIsOpen(value);
		onDropdownVisibleChange?.(value);
	}

	if (loading) {
		return <LoaderOverlay hasIcon={!!value?.length} className={className} />;
	}

	return (
		<CustomSelectContainer hasIcon={!!value?.length} className={className}>
			<MultiSelectInput
				{...props}
				value={value}
				isOpen={isOpen}
				options={options}
				placeholder={placeholder}
				onChange={onChange}
				onDropdownVisibleChange={handleOnDropdownVisibleChange}
			/>
			<TriggerIcons isOpen={isOpen} showEditIcon={!!value?.length} />
		</CustomSelectContainer>
	);
}
